import styled from 'styled-components';

/**
 * Shared styles for header components (AppBar and ResaleAppBar)
 * Extracted to reduce code duplication and ensure consistency
 */

export const BreadcrumbsContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 480px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const OptionsContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: space-between;
    gap: 0;
  }
`;

export const LocaleContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
`;
